import useWidth from '@/helpers/widthUtil';
import { Empty, Pagination, Skeleton } from 'antd';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';

const LiveRoom = () => {
  const { isMobile } = useWidth();

  const meetings = useSelector((state: any) => state.roomReducer?.meetingList);
  return (
    <Skeleton loading={meetings.loading}>
      <div className="row">
        {meetings?.data?.length !== 0 ? (
          meetings?.data?.map((meeting, key) => (
            <div className={`col-lg-12 ${isMobile ? 'mt-3' : 'mb-3'}`} key={key}>
              <div className="card card-block p-3 card-stretch">
                <div className="card-body">
                  <div className="d-flex flex-wrap align-items-center justify-content-between">
                    <div className="d-flex flex-wrap align-items-center">
                      <div className="date mr-3">
                        <h6 className="text-danger">
                          {moment(meeting.start_time, 'HH:mm').format('LT')} -{' '}
                          {moment(meeting.end_time, 'HH:mm:ss').format('LT')}
                        </h6>
                      </div>
                      <div className="border-left-event pl-3">
                        <div className="d-flex media align-items-top">
                          <h5>{meeting?.topic}</h5>
                          <div className="badge badge-danger ml-3">
                            Live
                            <span className="live-icon" />
                          </div>
                        </div>
                        <div className="media align-items-center">
                          <p className="mb-0">
                            <i className="las la-map-marker mr-2 text-info"></i>Date:{' '}
                            {moment(meeting?.start_date).format('D MMMM YYYY')}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <>
                  <a className="btn btn-outline-danger ml-auto rounded">Join</a>
                </>
              </div>
            </div>
          ))
        ) : (
          <Empty description="No Live Classes for now" />
        )}
        {/* {
                meetings?.data?.length !== 0 &&
                <Pagination
                    total={meetings?.meta?.total}
                    showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
                    defaultPageSize={meetings?.meta?.per_page}
                    defaultCurrent={meetings?.meta?.page}
                    onChange={handlePagination}
                />
            } */}
      </div>
    </Skeleton>
  );
};
export default LiveRoom;
